import { initLegalInfo } from './legalInfo';
import { loadSwiper } from './swiperLoader';
import { setSameHeight } from './utils';

//-----------------------------------
// ### Aponeo Sliders ###
//------------------------------------

// Global Sliders Array
const apnSliders = [];

// Initiate Sliders if present on page
export function initiateSliders() {
  if ($('.swiper-container').length === 0) {
    return;
  }

  loadSwiper().done(() => {
    // Big slider on e.g. start page
    if ($('.apn-teaser-hero-slider').length) {
      $('.apn-teaser-hero-slider .swiper-container').each((index, element) => {
        let apn_compagnion_slider = null;
        if ($(element).parents('.with-compagnion').length) {
          const $sharedParent = $(element).closest('.row');
          const $compagnionSlider = $('.apn-compagnion-wrapper .swiper-container', $sharedParent);
          if ($compagnionSlider.length) {
            apn_compagnion_slider = new Swiper($compagnionSlider, {
              loop: true,
              allowTouchMove: false,
              preventClicks: false,
            });
          }
        }

        let initialized = false;
        const apn_teaser_hero_slider = new Swiper(element, {
          pagination: {
            el: $('.swiper-pagination', element),
            type: 'bullets',
            clickable: true,
          },
          navigation: {
            nextEl: $('.swiper-button-next', element),
            prevEl: $('.swiper-button-prev', element),
          },
          loop: true,
          autoplay: {
            delay: 8000,
          },
          on: {
            init: function () {
              initialized = true;
              initLegalInfo(true);
            },
            slideNextTransitionStart: function () {
              if (apn_compagnion_slider && initialized) {
                apn_compagnion_slider.slideNext();
              }
            },
            slidePrevTransitionStart: function () {
              if (apn_compagnion_slider && initialized) {
                apn_compagnion_slider.slidePrev();
              }
            },
          },
        });
      });
    }

    // Banner slider on e.g. start page
    if ($('.apn-teaser-banner-slider').length) {
      $('.apn-teaser-banner-slider .swiper-container').each((index, element) => {
        const apn_teaser_banner_slider = new Swiper(element, {
          pagination: {
            el: $('.swiper-pagination', element),
            type: 'bullets',
            clickable: true,
          },
          navigation: {
            nextEl: $('.swiper-button-next', element),
            prevEl: $('.swiper-button-prev', element),
          },
          loop: true,
          autoplay: {
            delay: 8000,
          },
          on: {
            init: function () {
              initLegalInfo(true);
            },
          },
        });
      });
    }

    // Slider on Product Detail Page
    let apnProductDetailSliders = [];
    if ($('.apn-product-detail-slider').length) {
      $('.apn-product-detail-slider .swiper-container').each(function (index, element) {
        const apn_product_detail_slider = new Swiper($('.apn-product-detail-slider .swiper-container')[index], {
          pagination: {
            el: $('.apn-product-detail-slider .swiper-pagination')[index],
            type: 'bullets',
            clickable: true,
          },
          on: {
            slideChange: () => {
              if (apnProductDetailThumbnailSliders[index]) {
                // slide the thumbnail slider
                apnProductDetailThumbnailSliders[index].slideTo(element.realIndex);
                // set active class for active preview
                apnProductDetailThumbnailSliders[index].slides.removeClass('swiper-slide-fake-active');
                $(apnProductDetailThumbnailSliders[index].slides[apnProductDetailSliders[index].activeIndex]).addClass(
                  'swiper-slide-fake-active',
                );
              }
            },
          },
        });
        apnProductDetailSliders[index] = apn_product_detail_slider;
      });
    }

    // Thumbnail slider on Product Detail Page
    let apnProductDetailThumbnailSliders = [];
    if ($('.apn-product-detail-thumbnail-slider').length) {
      $('.apn-product-detail-thumbnail-slider .swiper-container').each((i, e) => {
        const apn_product_detail_thumbnail_slider = new Swiper(
          $('.apn-product-detail-thumbnail-slider .swiper-container')[i],
          {
            slidesPerView: 'auto',
            navigation: {
              nextEl: $('.apn-product-detail-thumbnail-slider .swiper-button-next')[i],
              prevEl: $('.apn-product-detail-thumbnail-slider .swiper-button-prev')[i],
            },
            on: {
              tap: (event) => {
                const slide = $(event.target).closest('.swiper-slide');
                if (slide && typeof slide.data('index') !== 'undefined') {
                  apnProductDetailSliders[i].slideTo(slide.data('index'));
                }
              },
            },
          },
        );
        apnProductDetailThumbnailSliders[i] = apn_product_detail_thumbnail_slider;
      });
    }

    // Category Slider
    if ($('.apn-teaser-category-slider').length && $(window).width() < 992) {
      $('.apn-teaser-category-slider .swiper-container').each((i) => {
        const apn_teaser_category_slider = new Swiper($('.apn-teaser-category-slider .swiper-container')[i], {
          slidesPerView: '4',
          freeMode: true,
          spaceBetween: 15,
        });
      });
    }

    // Product Slider -- only initialise non empty ones:
    if ($('.apn-teaser-product-slider:has(.swiper-wrapper > *)').length) {
      $('.apn-teaser-product-slider .swiper-container').each((i, element) => {
        const maxSlides = $(element).hasClass('max-slides-4') ? 4 : 5;
        const numberOfSlides = $(element).children('.swiper-wrapper')[0].childElementCount;
        const apn_teaser_product_slider = new Swiper($(element), {
          slidesPerView: 'auto',
          slidesPerGroup: maxSlides,
          breakpoints: {
            991: {
              slidesPerGroup: 1,
            },
          },
          navigation: {
            nextEl: $(element).siblings('.swiper-button-next'),
            prevEl: $(element).siblings('.swiper-button-prev'),
          },
        });

        setSameHeight(element, '.apn-product-list-item-header');

        if (numberOfSlides <= maxSlides) {
          $(element).siblings('.swiper-button-next').removeClass('d-lg-block');
          $(element).siblings('.swiper-button-prev').removeClass('d-lg-block');
        }
      });
    }

    // Auto Slider
    if ($('.apn-teaser-auto-slider').length) {
      $('.apn-teaser-auto-slider .swiper-container').each((i) => {
        const apn_teaser_auto_slider = new Swiper($('.apn-teaser-auto-slider .swiper-container')[i], {
          autoplay: {
            delay: 2500,
          },
        });
      });
    }

    // Benefits Slider
    if ($('.apn-teaser-benefits-slider').length) {
      let _slidesPerView = $(window).width() > 767 ? 3 : 2;
      $('.apn-teaser-benefits-slider .swiper-container').each((i) => {
        const apn_teaser_benefits_slider = new Swiper($('.apn-teaser-benefits-slider .swiper-container')[i], {
          slidesPerView: _slidesPerView,
          autoplay: {
            delay: 4000,
          },
        });
      });
    }

    // Customer Slider
    if ($('.apn-teaser-customer-slider').length) {
      let _slidesPerView = $(window).width() > 991 ? 2 : 1;
      $('.apn-teaser-customer-slider .swiper-container').each((i) => {
        const apn_teaser_benefits_slider = new Swiper($('.apn-teaser-customer-slider .swiper-container')[i], {
          slidesPerView: _slidesPerView,
          spaceBetween: 30,
          autoplay: {
            delay: 4000,
          },
        });
      });
    }

    // Brand Slider
    if ($('.apn-teaser-brand-slider').length) {
      $('.apn-teaser-brand-slider .swiper-container').each(function (i) {
        var apn_teaser_brand_slider = new Swiper($('.apn-teaser-brand-slider .swiper-container')[i], {
          slidesPerView: 3.5,
          spaceBetween: 15,
          // Responsive breakpoints
          breakpoints: {
            // when window width is >= 767px
            767: {
              slidesPerView: 3.5,
              spaceBetween: 15,
            },
            // when window width is >= 991px
            991: {
              slidesPerView: 3.5,
              spaceBetween: 15,
            },
          },
        });
      });
    }

    // Advisor Slider
    if ($('.apn-teaser-advisor-slider').length && $(window).width() < 992) {
      $('.apn-teaser-advisor-slider .swiper-container').each((i) => {
        const apn_teaser_advisor_slider = new Swiper($('.apn-teaser-advisor-slider .swiper-container')[i], {
          slidesPerView: 'auto',
          spaceBetween: 0,
          navigation: {
            nextEl: $('.apn-teaser-advisor-slider .swiper-button-next')[i],
            prevEl: $('.apn-teaser-advisor-slider .swiper-button-prev')[i],
          },
        });
      });
    }

    if ($('.apn-bonus-scheme__overview__slider').length) {
      $('.apn-bonus-scheme__overview__slider.swiper-container').each(function () {
        const apnBonusSchemeOverviewSlider = new Swiper(this, {
          navigation: {
            nextEl: $('.swiper-button-next', this),
            prevEl: $('.swiper-button-prev', this),
          },
          loop: true,
          autoplay: {
            delay: 8000,
          },
          slidesPerView: 2,
          breakpoints: {
            991: {
              slidesPerView: 1,
            },
          },
          on: {
            init: function () {
              initLegalInfo(true);
            },
          },
        });
      });
    }

    // Product List Combi Slider
    let productCombiSlider = {};

    if ($('.product-combi__slider .swiper-container').length) {
      $('.product-combi__slider .swiper-container').each((index, element) => {
        const activeIndex = $(element).find('.swiper-slide:has(.active)').index();
        productCombiSlider = new Swiper(element, {
          initialSlide: activeIndex ?? 0,
          slidesPerView: 'auto',
          spaceBetween: 15,
          freeMode: true,
        });

        if (window.matchMedia('screen and (min-width: 768px)').matches) {
          if (productCombiSlider !== undefined) {
            productCombiSlider.destroy(false, true);
          }
        }
      });
    }

    // Add Sliders to global Array sliders
    $('.swiper-container').each(function (index, element) {
      const swiper = this.swiper;
      if (swiper) {
        apnSliders.push(swiper);
      }
    });
  });
}

// Destroy Sliders
export function destroySliders() {
  $(apnSliders).each((index, element) => {
    element.destroy(false, true);
  });
}

// Toggle re-initialization and destruction of sliders if user switchs between
// tablet and desktop view
let windowWidth = $(window).width();
$(window).resize(() => {
  if ($(window).width() !== windowWidth) {
    destroySliders();
    initiateSliders();
    windowWidth = $(window).width();
  }
});
